export const FEATURE_SEARCH_API = 'SearchApi';
export const FEATURE_SEARCH_API_OFF = 'SearchApiOff';
export const FEATURE_TEST = 'TestFeature';
